'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['sin', 'cos', 'tan', 'arcsin', 'arccos', 'arctan', 'log', 'ln', 'sqrt', 'max', 'min'];